/** Parse a price string like "7,20€" to a float */
export function parsePrice(value) {
  if (value === null || value === undefined) return 0

  if (typeof value === 'number') return value

  if (typeof value !== 'string') {
    console.warn('⚠️ parsePrice reçoit un type invalide:', value)
    return 0
  }

  return (
    parseFloat(
      value
        .replace(',', '.')
        .replace('€', '')
        .trim()
    ) || 0
  )
}

/** Format a float to "7,20€" */
export function formatPrice(n) {
  return n.toFixed(2).replace('.', ',') + '€'
}


